import { Outlet } from 'react-router-dom';
import { AiChatMount } from '@/components/ai/AiChatMount';
import { AppInstallPrompt } from '@/components/common/AppInstallPrompt';
import { AiChatProvider } from '@/components/ai/AiChatProvider';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';

export function Layout() {
  return (
    <AiChatProvider>
      <div className="flex min-h-screen flex-col">
        <Navbar />
        <main className="flex-1"><Outlet /></main>
        <Footer />
        {/* Mounted above <Outlet/> so a conversation survives navigation to a clin… */}
        <AiChatMount />
        <AppInstallPrompt />
      </div>
    </AiChatProvider>
  );
}
